/**
 * GENERATED FILE — do not edit by hand.
 *
 * The operational Data Explorer config graph (pict-dataexplorer). Relationships are derived from the live
 * schema (lib/headlight_model/json/Headlight.json); scope + presentation come from Explorer-Curation.js.
 * Regenerate:  node source/data-explorer/build-explorer-config.js
 */

module.exports = {
	"URLPrefix": "/1.0/",
	"PageSize": 25,
	"MaxDepth": 8,
	"Roots": [
		{
			"Label": "Projects",
			"Entity": "Project"
		},
		{
			"Label": "Contracts",
			"Entity": "Contract"
		},
		{
			"Label": "Users",
			"Entity": "User"
		},
		{
			"Label": "Organizations",
			"Entity": "Organization"
		},
		{
			"Label": "Materials",
			"Entity": "Material"
		},
		{
			"Label": "Pay Items",
			"Entity": "PayItem"
		},
		{
			"Label": "Specification Sets",
			"Entity": "TestSpecificationSet"
		},
		{
			"Label": "Tests",
			"Entity": "Test"
		},
		{
			"Label": "Labs",
			"Entity": "Lab"
		},
		{
			"Label": "Products",
			"Entity": "Product"
		},
		{
			"Label": "Mix Designs",
			"Entity": "MixDesign"
		}
	],
	"Entities": {
		"Project": {
			"Lite": [
				"Name",
				"Status",
				"IDProjectType",
				"IDContract",
				"IDOrganization",
				"GUIDProject"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Status~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Project Type",
					"Entity": "ProjectType",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDProjectType"
					}
				},
				{
					"Label": "Contract",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Primary Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Users",
					"Entity": "User",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectUserJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDUser"
					}
				},
				{
					"Label": "Organizations",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectOrganizationJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDOrganization"
					}
				},
				{
					"Label": "Observation Tags",
					"Entity": "ObservationTag",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ObservationTagProjectJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDObservationTag"
					}
				},
				{
					"Label": "Report Instances",
					"Entity": "ReportNamedInstance",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ReportNamedInstanceProjectJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDReportNamedInstance"
					}
				},
				{
					"Label": "Bid Items",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Line Items",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Labs",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectLabJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDLab"
					}
				},
				{
					"Label": "Observation Types",
					"Entity": "ProjectObservationManifestJoin",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Sample Plan",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "LineItem",
						"ParentKey": "IDProject",
						"ChildKey": "IDPayItem"
					}
				}
			]
		},
		"Contract": {
			"Lite": [
				"Name",
				"Status",
				"IDOrganization",
				"IDContractType",
				"GUIDContract"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Status~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Contract Type",
					"Entity": "ContractType",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDContractType"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Bid Items",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Line Items",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDContract"
					}
				}
			]
		},
		"User": {
			"Lite": [
				"NameFirst",
				"NameLast",
				"LoginID",
				"Email",
				"Role",
				"Title",
				"IDRole",
				"IDProjectOffice",
				"GUIDUser"
			],
			"Display": {
				"Title": "{~D:Record.NameFirst~} {~D:Record.NameLast~}",
				"Subtitle": "{~D:Record.LoginID~}"
			},
			"Sort": "Title",
			"Children": [
				{
					"Label": "Role",
					"Entity": "Role",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDRole"
					}
				},
				{
					"Label": "Roles",
					"Entity": "Role",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "UserRoleJoin",
						"ParentKey": "IDUser",
						"ChildKey": "IDRole"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectUserJoin",
						"ParentKey": "IDUser",
						"ChildKey": "IDProject"
					}
				}
			]
		},
		"Organization": {
			"Lite": [
				"Name",
				"Type",
				"GUIDOrganization"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Type~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectOrganizationJoin",
						"ParentKey": "IDOrganization",
						"ChildKey": "IDProject"
					}
				},
				{
					"Label": "Contracts",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Observation Tags",
					"Entity": "ObservationTag",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Bid Items",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Labs",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Mix Designs",
					"Entity": "MixDesign",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Products",
					"Entity": "Product",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "OrganizationMaterialJoin",
						"ParentKey": "IDOrganization",
						"ChildKey": "IDMaterial"
					}
				}
			]
		},
		"Role": {
			"Lite": [
				"Name",
				"Type",
				"GUIDRole"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Type~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Users",
					"Entity": "User",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDRole"
					}
				},
				{
					"Label": "Users",
					"Entity": "User",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "UserRoleJoin",
						"ParentKey": "IDRole",
						"ChildKey": "IDUser"
					}
				}
			]
		},
		"Material": {
			"Lite": [
				"Name",
				"ItemCode",
				"GUIDMaterial"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.ItemCode~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Labs",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "LabMaterialAssignment",
						"ParentKey": "IDMaterial",
						"ChildKey": "IDLab"
					}
				},
				{
					"Label": "Mix Designs",
					"Entity": "MixDesign",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDMaterial"
					}
				},
				{
					"Label": "Pay Items",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "MaterialPayItemJoin",
						"ParentKey": "IDMaterial",
						"ChildKey": "IDPayItem"
					}
				},
				{
					"Label": "Products",
					"Entity": "Product",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDMaterial"
					}
				},
				{
					"Label": "Organizations",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "OrganizationMaterialJoin",
						"ParentKey": "IDMaterial",
						"ChildKey": "IDOrganization"
					}
				},
				{
					"Label": "Test Specifications",
					"Entity": "TestSpecification",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestSpecificationMaterialJoin",
						"ParentKey": "IDMaterial",
						"ChildKey": "IDTestSpecification"
					}
				},
				{
					"Label": "Tests",
					"Entity": "ProjectLineItemMaterialTest",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDMaterial",
						"ContextKeys": [
							"IDLineItem"
						],
						"RequireContext": [
							"IDLineItem"
						]
					}
				}
			]
		},
		"Product": {
			"Lite": [
				"Name",
				"ProductCategory",
				"IDMaterial",
				"IDOrganization",
				"GUIDProduct"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.ProductCategory~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Material",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDMaterial"
					}
				},
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				}
			]
		},
		"MixDesign": {
			"Lite": [
				"Name",
				"MaterialCode",
				"IDMaterial",
				"IDOrganization",
				"IDMixType",
				"GUIDMixDesign"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.MaterialCode~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Material",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDMaterial"
					}
				},
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				}
			]
		},
		"PayItem": {
			"Lite": [
				"Description",
				"ItemCode",
				"Section",
				"FunctionalClass",
				"Name",
				"IDTestSpecificationSet",
				"GUIDPayItem"
			],
			"Display": {
				"Title": "Description",
				"Subtitle": "{~D:Record.ItemCode~}"
			},
			"Sort": "ItemCode",
			"Children": [
				{
					"Label": "Specification Set",
					"Entity": "TestSpecificationSet",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTestSpecificationSet"
					}
				},
				{
					"Label": "Bid Items",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDPayItem"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "MaterialPayItemJoin",
						"ParentKey": "IDPayItem",
						"ChildKey": "IDMaterial"
					}
				},
				{
					"Label": "Line Items",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDPayItem",
						"ContextKeys": [
							"IDProject"
						],
						"RequireContext": [
							"IDProject"
						]
					}
				}
			],
			"Filter": "FBV~Description~NE~",
			"ColumnBlacklist": [
				"ExtendedJSON"
			]
		},
		"TestSpecificationSet": {
			"Lite": [
				"Name",
				"Year",
				"GUIDTestSpecificationSet"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Year~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Pay Items",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDTestSpecificationSet"
					}
				},
				{
					"Label": "Tests",
					"Entity": "Test",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestSpecificationSetTestJoin",
						"ParentKey": "IDTestSpecificationSet",
						"ChildKey": "IDTest"
					}
				},
				{
					"Label": "Test Specifications",
					"Entity": "TestSpecification",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDTestSpecificationSet"
					}
				}
			]
		},
		"TestSpecification": {
			"Lite": [
				"Name",
				"Description",
				"IDTestSpecificationSet",
				"GUIDTestSpecification"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Description~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Specification Set",
					"Entity": "TestSpecificationSet",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTestSpecificationSet"
					}
				},
				{
					"Label": "Requirements",
					"Entity": "TestSpecificationRequirement",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDTestSpecification"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestSpecificationMaterialJoin",
						"ParentKey": "IDTestSpecification",
						"ChildKey": "IDMaterial"
					}
				}
			]
		},
		"TestSpecificationRequirement": {
			"Lite": [
				"Name",
				"IDTestSpecification",
				"IDTest",
				"GUIDTestSpecificationRequirement"
			],
			"Display": {
				"Title": "Name"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Test Specification",
					"Entity": "TestSpecification",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTestSpecification"
					}
				},
				{
					"Label": "Test",
					"Entity": "Test",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTest"
					}
				}
			]
		},
		"Test": {
			"Lite": [
				"Name",
				"Description",
				"GUIDTest"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Description~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Labs",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestLabJoin",
						"ParentKey": "IDTest",
						"ChildKey": "IDLab"
					}
				},
				{
					"Label": "Specification Sets",
					"Entity": "TestSpecificationSet",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestSpecificationSetTestJoin",
						"ParentKey": "IDTest",
						"ChildKey": "IDTestSpecificationSet"
					}
				},
				{
					"Label": "Requirements",
					"Entity": "TestSpecificationRequirement",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDTest"
					}
				}
			]
		},
		"Lab": {
			"Lite": [
				"Name",
				"IDOrganization",
				"IDOrganizationAddress",
				"GUIDLab"
			],
			"Display": {
				"Title": "Name"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Tests",
					"Entity": "Test",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestLabJoin",
						"ParentKey": "IDLab",
						"ChildKey": "IDTest"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "LabMaterialAssignment",
						"ParentKey": "IDLab",
						"ChildKey": "IDMaterial"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectLabJoin",
						"ParentKey": "IDLab",
						"ChildKey": "IDProject"
					}
				}
			]
		},
		"LineItem": {
			"Lite": [
				"Name",
				"ItemCode",
				"IDFundingCategory",
				"IDPayItem",
				"IDBidItem",
				"IDContract",
				"IDProject",
				"Status",
				"GUIDLineItem"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.ItemNumber~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Pay Item",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDPayItem"
					}
				},
				{
					"Label": "Bid Item",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDBidItem"
					}
				},
				{
					"Label": "Contract",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Project",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Observation Tags",
					"Entity": "ObservationTag",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDLineItem"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectLineItemMaterialTest",
						"ParentKey": "IDLineItem",
						"ChildKey": "IDMaterial"
					}
				}
			]
		},
		"BidItem": {
			"Lite": [
				"Name",
				"Units",
				"IDContract",
				"IDProject",
				"IDPayItem",
				"IDOrganization",
				"GUIDBidItem"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Units~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Contract",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Project",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Pay Item",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDPayItem"
					}
				},
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Observation Tags",
					"Entity": "ObservationTag",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDBidItem"
					}
				},
				{
					"Label": "Line Items",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDBidItem"
					}
				}
			]
		},
		"ObservationManifest": {
			"Lite": [
				"Name",
				"Category",
				"GUIDObservationManifest"
			],
			"Display": {
				"Title": "DisplayName",
				"Subtitle": "{~D:Record.Category~}"
			},
			"Sort": "Name",
			"Children": []
		},
		"ProjectType": {
			"Lite": [
				"Name",
				"Description",
				"IDProgram",
				"GUIDProjectType"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Description~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDProjectType"
					}
				}
			]
		},
		"ContractType": {
			"Lite": [
				"Name",
				"Description",
				"GUIDContractType"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Description~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Contracts",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDContractType"
					}
				}
			]
		},
		"ObservationTag": {
			"Lite": [
				"Description",
				"IDOrganization",
				"IDBidItem",
				"IDLineItem",
				"GUIDObservationTag"
			],
			"Display": {
				"Title": "Description"
			},
			"Sort": "Description",
			"Children": [
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Bid Item",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDBidItem"
					}
				},
				{
					"Label": "Line Item",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDLineItem"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ObservationTagProjectJoin",
						"ParentKey": "IDObservationTag",
						"ChildKey": "IDProject"
					}
				}
			]
		},
		"ReportNamedInstance": {
			"Lite": [
				"Name",
				"IDReportArchetype",
				"GUIDReportNamedInstance"
			],
			"Display": {
				"Title": "Name"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ReportNamedInstanceProjectJoin",
						"ParentKey": "IDReportNamedInstance",
						"ChildKey": "IDProject"
					}
				}
			]
		},
		"ProjectObservationManifestJoin": {
			"IDField": "IDProjectObservationManifestJoin",
			"Lite": [
				"ObservationManifestName",
				"IDProject"
			],
			"Display": {
				"Title": "ObservationManifestName"
			}
		},
		"ProjectLineItemMaterialTest": {
			"IDField": "IDProjectLineItemMaterialTest",
			"Lite": [
				"TestDescription",
				"SampleType",
				"Intent",
				"Frequency",
				"Units",
				"SampleSize",
				"IDTest",
				"IDLab",
				"IDMaterial",
				"GUIDProjectLineItemMaterialTest"
			],
			"Display": {
				"Title": "TestDescription",
				"Subtitle": "{~D:Record.SampleType~}"
			},
			"Sort": "SampleType",
			"Children": [
				{
					"Label": "Test",
					"Entity": "Test",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTest"
					}
				},
				{
					"Label": "Lab",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDLab"
					}
				},
				{
					"Label": "Material",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDMaterial"
					}
				}
			]
		}
	}
};
